import uirouter from '@uirouter/angularjs';
import common from 'app/modules/common';

export default angular
  .module('app.holding.dashboard.overview', [
    'angular-promise-cache',
    uirouter,
    common,
  ])
  .name;

require('./components/overview-sidebar-markets/overview-sidebar-markets');
require('./components/overview-sidebar-research/overview-sidebar-research');
require('./directives/balance-total/balance-total');
require('./directives/percentage-change/percentage-change');
require('./directives/statement/statement');
require('./directives/statement-movements/statement-movements');
require('./directives/statement-rates/statement-rates');
require('./directives/statement-transactions/statement-transactions');
require('./directives/statement-total/statement-total');
require('./directives/transaction-item/transaction-item');
require('./filters/end-of-month');
require('./filters/start-of-month');
require('./filters/transaction-detail-type');
require('./filters/transaction-type');
require('./services/balances');
require('./services/markets');
require('./services/research');
require('./services/statements');
require('./services/transactions');
require('./states/overview');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/overview/index.js